import { styled } from '@linaria/react';

import { Typography } from '~/shared/ui/Typography/Typography';

export const WarningMessage = styled(Typography.H4)`
  color: var(--color-system-orange);
`;
